import React from 'react';
import './PaymentFilesModal.scss';

/**
 * Modal for viewing payment attached files (PDFs)
 */
const PaymentFilesModal = ({ isOpen, onClose, payment, paymentType }) => {
  if (!isOpen || !payment) return null;

  const files = payment.pdfs || [];
  const images = payment.images || [];
  const allFiles = [...files, ...images];

  const handleFileClick = (fileUrl) => {
    // Open file in new tab
    window.open(fileUrl, '_blank');
  };

  const getFileName = (url) => {
    if (!url) return 'Unknown file';
    const parts = url.split('/');
    return parts[parts.length - 1] || 'File';
  };

  const getFileIcon = (url) => {
    if (!url) return '📄';
    const lower = url.toLowerCase();
    if (lower.endsWith('.pdf')) return '📕';
    if (lower.endsWith('.jpg') || lower.endsWith('.jpeg') || lower.endsWith('.png') || lower.endsWith('.gif')) return '🖼️';
    return '📄';
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="payment-files-modal__backdrop" onClick={handleBackdropClick}>
      <div className="payment-files-modal">
        {/* Header */}
        <div className="payment-files-modal__header">
          <h2 className="payment-files-modal__title">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14,2 14,8 20,8" />
            </svg>
            Payment Files
          </h2>
          <button className="payment-files-modal__close-btn" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="payment-files-modal__content">
          {allFiles.length === 0 ? (
            <div className="payment-files-modal__empty">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M9 12h6M12 9v6M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0z" />
              </svg>
              <p>No files attached to this payment</p>
            </div>
          ) : (
            <div className="payment-files-modal__list">
              {allFiles.map((fileUrl, index) => (
                <div 
                  key={index} 
                  className="payment-files-modal__file"
                  onClick={() => handleFileClick(fileUrl)}
                >
                  <span className="payment-files-modal__file-icon">
                    {getFileIcon(fileUrl)}
                  </span>
                  <span className="payment-files-modal__file-name">
                    {getFileName(fileUrl)}
                  </span>
                  <span className="payment-files-modal__file-action">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                      <polyline points="15 3 21 3 21 9" />
                      <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="payment-files-modal__footer">
          <button className="payment-files-modal__btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFilesModal;


